<script setup>
import {computed, reactive} from "vue";
import {getRoute} from "@/hooks/getRoute.js";
import YTCard from "@/components/YTCard/newIndex.vue";

const { route } = getRoute()
const qrCodeNo = computed(() => route.query.qrCodeNo || "QM0001")

// 二维码图片占位数据
const qrCodeImage = computed(() => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160">
      <rect width="160" height="160" fill="#fff"/>
      <rect x="14" y="14" width="42" height="42" fill="#1f2d3d"/>
      <rect x="22" y="22" width="26" height="26" fill="#fff"/>
      <rect x="29" y="29" width="12" height="12" fill="#1f2d3d"/>
      <rect x="104" y="14" width="42" height="42" fill="#1f2d3d"/>
      <rect x="112" y="22" width="26" height="26" fill="#fff"/>
      <rect x="119" y="29" width="12" height="12" fill="#1f2d3d"/>
      <rect x="14" y="104" width="42" height="42" fill="#1f2d3d"/>
      <rect x="22" y="112" width="26" height="26" fill="#fff"/>
      <rect x="29" y="119" width="12" height="12" fill="#1f2d3d"/>
      <rect x="72" y="18" width="10" height="10" fill="#1f2d3d"/>
      <rect x="88" y="34" width="10" height="10" fill="#1f2d3d"/>
      <rect x="70" y="66" width="12" height="12" fill="#1f2d3d"/>
      <rect x="94" y="70" width="10" height="10" fill="#1f2d3d"/>
      <rect x="120" y="76" width="12" height="12" fill="#1f2d3d"/>
      <rect x="62" y="94" width="10" height="10" fill="#1f2d3d"/>
      <rect x="84" y="102" width="14" height="14" fill="#1f2d3d"/>
      <rect x="110" y="106" width="10" height="10" fill="#1f2d3d"/>
      <rect x="132" y="124" width="12" height="12" fill="#1f2d3d"/>
      <rect x="66" y="130" width="10" height="10" fill="#1f2d3d"/>
      <rect x="102" y="136" width="10" height="10" fill="#1f2d3d"/>
    </svg>
  `
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
})

// 二维码详情信息
const qrCodeInfo = computed(() => ({
  qrCodeNo: qrCodeNo.value,
  createTime: "2026-06-12 12:06:12",
  bindStatus: "已绑定",
}))

// 当前绑定车辆信息
const currentBicycleInfo = reactive({
  assetOwner: "BIKING UP",
  brandName: "捷安特",
  bicycleModel: "ALight1",
  bicycleColor: "黑色",
  ageRange: "成人",
  sponsor: "捷安特上海有限公司",
  newness: "9成新",
  place: "金门湾旅游度假村",
  placeTime: "2026-06-06",
})

// 历史车辆绑定记录
const bindHistory = [
  {
    index: 1,
    assetOwner: "BIKING UP",
    brandName: "捷安特",
    bicycleModel: "ALight1",
    bicycleColor: "黑色",
    ageRange: "成人",
    sponsor: "捷安特上海有限公司",
    newness: "9成新",
    place: "金门湾旅游度假村",
    placeTime: "2026-06-06",
    bindTime: "2026-05-12 12:10:12",
    unbindTime: "2026-06-15 12:10:12",
  },
]

const historyHeaders = [
  { title: "序号", key: "index", align: "center", nowrap: true },
  { title: "资产归属", key: "assetOwner", align: "center", nowrap: true },
  { title: "车辆品牌", key: "brandName", align: "center", nowrap: true },
  { title: "车辆型号", key: "bicycleModel", align: "center", nowrap: true },
  { title: "车辆颜色", key: "bicycleColor", align: "center", nowrap: true },
  { title: "车辆使用年龄段", key: "ageRange", align: "center", nowrap: true },
  { title: "提供方/赞助方", key: "sponsor", align: "center", nowrap: true },
  { title: "车辆新旧程度", key: "newness", align: "center", nowrap: true },
  { title: "车辆当前放置场地", key: "place", align: "center", nowrap: true },
  { title: "车辆放置时间", key: "placeTime", align: "center", nowrap: true },
  { title: "绑定时间", key: "bindTime", align: "center", nowrap: true },
  { title: "解绑时间", key: "unbindTime", align: "center", nowrap: true },
]

// 处理二维码下载
const handleDownloadQRCode = () => {}
</script>

<template>
  <div class="detail-page flex_align_t">
    <aside class="qr-preview-panel">
      <YTCard :title="`二维码图片`" :mg_b="0">
        <template #container>
          <div class="qr-image-card">
            <img class="qr-image" :src="qrCodeImage" alt="二维码图片" />
            <el-link type="primary" :underline="false" class="qr-download-link" @click="handleDownloadQRCode">
              二维码下载
            </el-link>
          </div>
        </template>
      </YTCard>
    </aside>

    <main class="container_box qr-detail-content">
      <YTCard :title="`二维码信息`">
        <template #container>
          <el-form class="qr-info-form" label-position="left" label-width="auto">
            <el-form-item label="二维码编号：">
              <el-input :model-value="qrCodeInfo.qrCodeNo" disabled class="qr-no-input" />
            </el-form-item>
            <el-form-item label="二维码生成时间：">
              <span>{{ qrCodeInfo.createTime }}</span>
            </el-form-item>
            <el-form-item label="绑定状态：">
              <span>{{ qrCodeInfo.bindStatus }}</span>
            </el-form-item>
          </el-form>
        </template>
      </YTCard>

      <YTCard :title="`当前绑定车辆信息`">
        <template #container>
          <el-form class="vehicle-info-form" label-position="left" label-width="auto">
            <el-form-item label="资产归属：">
              <span>{{ currentBicycleInfo.assetOwner }}</span>
            </el-form-item>
            <el-form-item label="车辆品牌：">
              <span>{{ currentBicycleInfo.brandName }}</span>
            </el-form-item>
            <el-form-item label="车辆型号：">
              <span>{{ currentBicycleInfo.bicycleModel }}</span>
            </el-form-item>
            <el-form-item label="车辆颜色：">
              <span>{{ currentBicycleInfo.bicycleColor }}</span>
            </el-form-item>
            <el-form-item label="车辆使用年龄段：">
              <span>{{ currentBicycleInfo.ageRange }}</span>
            </el-form-item>
            <el-form-item label="提供方/赞助方：">
              <span>{{ currentBicycleInfo.sponsor }}</span>
            </el-form-item>
            <el-form-item label="车辆新旧程度：">
              <span>{{ currentBicycleInfo.newness }}</span>
            </el-form-item>
            <el-form-item label="车辆当前放置场地：">
              <span>{{ currentBicycleInfo.place }}</span>
            </el-form-item>
            <el-form-item label="车辆放置时间：">
              <span>{{ currentBicycleInfo.placeTime }}</span>
            </el-form-item>
          </el-form>
        </template>
      </YTCard>

      <YTCard :title="`历史车辆绑定记录`" :mg_b="0">
        <template #container>
          <div class="history-table-wrap">
            <v-data-table
                class="history-table"
                :headers="historyHeaders"
                :items="bindHistory"
                :items-per-page="-1"
                :no-data-text="'没有更多数据了'"
                hover
            >
              <template v-slot:bottom></template>
            </v-data-table>
          </div>
        </template>
      </YTCard>
    </main>
  </div>
</template>

<style lang="scss" scoped>
.detail-page {
  width: 100%;
  min-height: 820px;
  gap: 20px;
  text-align: left;
}

.qr-preview-panel {
  flex: 0 0 220px;
  min-height: 100%;
  padding: 16px 0;
  box-sizing: border-box;
}

.qr-preview-panel :deep(.ytCard_box) {
  padding-left: 0;
}

.qr-image-card {
  width: 180px;
  margin: 0 auto;
  padding: 14px 10px 10px;
  background: #fff;
  text-align: center;
}

.qr-image {
  width: 110px;
  height: 110px;
  display: block;
  margin: 0 auto 8px;
}

.qr-download-link {
  font-size: 12px;
}

.qr-detail-content {
  flex: 1;
  min-width: 0;
  padding: 16px 16px 70px;
  box-sizing: border-box;
}

.qr-detail-content :deep(.ytCard_box) {
  padding-left: 0;
}

.qr-info-form,
.vehicle-info-form {
  max-width: 520px;
  margin-left: 20px;
}

.qr-info-form :deep(.el-form-item),
.vehicle-info-form :deep(.el-form-item) {
  margin-bottom: 12px;
}

.qr-no-input {
  width: 280px;
}

.vehicle-info-form :deep(.el-form-item__content) {
  color: #272539;
}

.history-table-wrap {
  max-width: 100%;
  margin-left: 0;
  overflow: hidden;
}

.history-table {
  width: 100%;
}

.history-table :deep(.v-table__wrapper) {
  overflow-x: auto;
}

.history-table :deep(table) {
  min-width: 1220px;
}

.history-table :deep(.v-data-table__th) {
  background: #f7f8fa;
}

@media (max-width: 900px) {
  .detail-page {
    display: block;
  }

  .qr-preview-panel {
    width: 100%;
    min-height: auto;
  }
}
</style>
